<script setup lang="ts">
import { watch } from 'vue'

import { useConfirmDeleteController } from '@/composables/current-student-advanced-standing-form/useConfirmDeleteController'
import ConfirmDeleteModal from './ConfirmDeleteModal.vue'

type ConfirmDeleteAction = () => Promise<void>

const props = defineProps<{
  modalIsShown: (modalId: string) => boolean
  modalIsActive: (modalId: string) => boolean
  syncModalVisibility: (modalId: string, visible: boolean) => void
  handleAuthSessionError: (error: unknown, behavior: 'redirect' | 'reload') => boolean
  getErrorMessage: (error: unknown) => string
}>()

const {
  confirmDeleteModalVisible,
  confirmDeleteError,
  confirmDeleteAlertTone,
  confirmDeleteMessage,
  openConfirmDelete,
  cancelConfirmDelete,
  runConfirmedDelete,
  showConfirmDeleteError,
  clearConfirmDeleteError,
} = useConfirmDeleteController({
  handleAuthSessionError: props.handleAuthSessionError,
  getErrorMessage: props.getErrorMessage,
})

watch(confirmDeleteModalVisible, (visible) => props.syncModalVisibility('ConfirmDeleteModal', visible))

defineExpose({
  openConfirmDelete: (message: string, action: ConfirmDeleteAction) => openConfirmDelete(message, action),
  cancelConfirmDelete,
  runConfirmedDelete,
  showConfirmDeleteError,
  clearConfirmDeleteError,
})
</script>

<template>
  <ConfirmDeleteModal
    :shown="modalIsShown('ConfirmDeleteModal')"
    :active="modalIsActive('ConfirmDeleteModal')"
    :message="confirmDeleteMessage"
    :error-message="confirmDeleteError"
    :alert-tone="confirmDeleteAlertTone"
    @cancel="cancelConfirmDelete"
    @delete="runConfirmedDelete"
  />
</template>
